import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import { persistedUser } from '../helpers/getLocalStorage';
import { RootState } from './RootState';
import userSlice from './user/userSlice';
import habiLeadsSlice, { initialState as initialStateHabiLeads } from './habi_leads/slice';
import prospectsSlice, { prospectsInitialState } from './prospects/prospectsSlice';
import analogInventorySlice, { initialState as initialStateAnalogInventory } from './analog_inventory/slice';
import thunk from 'redux-thunk';
import expandValiditySlice from './expand_validity/slice';
import UIMiddlewares from './ui/ui.middleware';
import uiSlice, { initialState as initialStateUI } from './ui/uiSlice';
import migrateFeedSlice, { initialMigrateFeedState } from './migrate_feed/migrateFeedSlice';
import migrateEmailContact, { initialMigrateEmailContact } from './migrate_email_contact/migrateEmailContact';
import unbanUser, { initialUnbanUser } from './unban_user/slice';
import qualifyForHabiSlice, { initialStateQualify } from './qualify_for_habi/qualifyForHabi.slice';
import { initialShoppingCart } from './shopping_cart/shopping_cart.initial';
import { shoppingCartSlice } from './shopping_cart/shopping_cart.slice';
import brokerconfigurationSlice, { initialBrokerConfigurationState } from './broker_configuration/slice';

const User = persistedUser();
const middleware: any = [thunk, ...UIMiddlewares];
export const preloadedState: RootState = {
    User: User?.User,
    HabiLeads: initialStateHabiLeads,
    prospects: prospectsInitialState,
    qualify: initialStateQualify,
    analogInventory: initialStateAnalogInventory,
    UI: initialStateUI,
    migrate_feed: initialMigrateFeedState,
    shopping_cart: initialShoppingCart,
    migrate_email_contact: initialMigrateEmailContact,
    unbanUser: initialUnbanUser,
    brokerConfiguration: initialBrokerConfigurationState
};

export const setupStore = (state?: PreloadedState<RootState>) => {
    return configureStore({
        reducer: {
            User: userSlice,
            HabiLeads: habiLeadsSlice,
            prospects: prospectsSlice,
            analogInventory: analogInventorySlice,
            expandValidity: expandValiditySlice,
            qualify: qualifyForHabiSlice,
            UI: uiSlice,
            migrate_feed: migrateFeedSlice,
            shopping_cart: shoppingCartSlice.reducer,
            migrate_email_contact: migrateEmailContact,
            unbanUser: unbanUser,
            brokerConfiguration: brokerconfigurationSlice
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                immutableCheck: false,
                serializableCheck: false,
            }).concat(middleware),
        preloadedState: state,
    });
};

// Infer the `RootState` and `AppDispatch` types from the store itself
export const store = setupStore(preloadedState);
export type AppStore = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
